import { Component, createRef } from 'react';
import isEqual from 'lodash-es/isEqual';
import cloneDeep from 'lodash-es/cloneDeep';
import orderBy from 'lodash-es/orderBy';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { Tab, Tabs as BootstrapTabs } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';

import WatchlistFilters from '../../WatchlistFilters';
import WatchlistRigthBar from '../../WatchlistRightBar';
import Preloader from '../../../Preloader';
import WatchlistNews from '../WatchlistNews';
import Filings from '../Filings';
import ChartsAndData from '../ChartsAndData';
import Info from '../Info';
import SentimentAnalysis from '../../../SentimentAnalysis';
import ChartsExpand from '../../../SEO_pages/ChartsExpand';
import SectorsTab from '../SectorsTab';
import InvestorRelations from '../InvestorRelations';
import ESGComponent from '../ESGComponent';
import InsiderTransactions from '../InsiderTransactions';
import NoWLData from '../NoWLData';
import CapitalStructure from '../../../SEO_pages/Topic/CapitalStructure';
import TopicTab from '../../../SEO_pages/TopicTabBodyCommon/TopicTab';
import ScrollableTabs from '../../../Shared/ScrollableTabs';

import TopicsSvc from '../../../../services/TopicsSvc';
import FilingsSvc from '../../../../services/dbServices/FilingsSvc';
import PresentationsSvc from '../../../../services/dbServices/PresentationsSvc';
import DCSCSectorsSvc from '../../../../services/dbServices/DCSCSectorsSvc';

import { loadIRStorageDataIntoRedux } from '../../../../actions/investorRelations.actions';
import { loadESGStorageDataIntoRedux } from '../../../../actions/esg.actions';

import { removeSlugFromPath } from '../../../../helpers/topicsHelpers';
import { queryItemWatchlistParser } from '../../../../helpers/watchlistHelperFunctions';
import { fetchTopicFullDetails } from '../../../../helpers/topicsApiHelpers';
import getInsiderTransactionTickers from '../../../../helpers/getInsiderTransactionTickers';
import { filingsParamGenerate, presentationsParamGenerate } from '../../../../helpers/identifierParamHelpers';

import {
  chartsTab,
  defaultTabs,
  esgTab,
  filingsTab,
  infoTab,
  insiderTransactionsTab,
  investorRelationsTab,
  capitalStructureTab,
  sectorsTab,
} from '../../../../data/watchlists/tabs';
import {
  COMMODITIES,
  CRYPTOCURRENCIES,
  EXCHANGE_TRADED_FUNDS,
  FOREIGN_EXCHANGE,
  INDICES,
  PRIVATE_COMPANIES,
  PUBLIC_COMPANIES,
} from '../../../../data/directory/topic_classes/topicClassTypes';
import { ESG, IR } from '../../../../data/features';
import { CAPITAL_STRUCTURE } from '../../../../data/directory/topic_classes/tabPaths';

import { orderValuesTab, sentimentValuesTab } from '../../../../data/filters/storyFilters';

import withComponentName from '../../../../decorators/withComponentName';
import * as storyFiltersActions from '../../../../actions/storyFilters.action';
import * as storyActions from '../../../../actions/stories.actions';
import * as watchlistActions from '../../../../actions/watchlistActions';
import * as searchActions from '../../../../actions/searchActions';
import StorageSvc from '../../../../services/StorageSvc';

import Styles from './styles.module.scss';
import tryInsiderTransactions from '../../../../helpers/tryInsiderTransactions';

const cx = classNames.bind(Styles);

export class WatchlistBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.getFoundID().id || 1,
      internalContentExpanded: false,
      isGettingData: true,
      tabsArray: defaultTabs,
      activeNewsTab: '1',
      activeTopic: null,
      topicAssetType: '',
      isChartExpandFirstTime: false,
      isChartExpand: false,
      isAdvancedView: true,
      activeOrderTab: 'top',
      activeSentimentTab: 'all',
      isWatchlistUpdated: false,
      insiderTransactionsExists: false,
      sectorsExists: false,
      insiderTransactionsTopics: [],
    };
    autoBind(this);
    this.tabsBar = createRef();
    this.allTabsChecked = false;
    this.userSimplifiedViewProperty = isMobileOnly ? 'user_newsfeed_advanced_view' : 'user_newsfeed_advanced_view_web';
    try {
      this.userSimplifiedView = JSON.parse(StorageSvc.getItem('userSimplifiedView'));
    } catch (e) {
      this.userSimplifiedView = false;
    }
  }

  componentDidMount() {
    const {
      history,
      activeWatchlistTopics,
      activateFilingsPreloader,
      loadIRStorageDataIntoRedux: propsIRAction,
      loadESGStorageDataIntoRedux: propsESGAction,
      actions,
    } = this.props;

    this.fetchSelectedTabs();
    const sentimentName = history.location.pathname.split('/').reverse()[0];

    this.setState({
      activeTab: this.getFoundID().id || 1,
      rendered: true,
      isAdvancedView: ((['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) || this.userSimplifiedView),
    }, () => {
      const { isAdvancedView, activeTab, activeSentimentTab } = this.state;
      StorageSvc.setItem(
        'selectedSentimentTab',
        JSON.stringify({ activeSentimentTab }),
      );
      actions.setSentimentTab(activeSentimentTab);
      if (((isAdvancedView && activeTab === 1) || activeTab !== 1)) {
        if (['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName[0])) {
          history.replace(`/watchlists/news/${activeSentimentTab}`);
        } else if (isAdvancedView && activeTab === 1) {
          history.replace(`/watchlists/news/${activeSentimentTab}`);
        } else {
          history.replace(`${history.location.pathname}`);
        }
      } else if (!isAdvancedView && activeTab === 1) {
        history.replace('/watchlists/news');
      } else {
        history.replace(`/watchlists/${this.getFoundID().path}`);
      }
    });

    propsIRAction();
    propsESGAction();

    if (activeWatchlistTopics.length || !activateFilingsPreloader) {
      this.checkForAllTabs();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      activeWatchlistTopics,
      location,
      activateFilingsPreloader,
      orderTab,
      permissions,
      userPreferences,
    } = this.props;

    if (
      !isEqual(activeWatchlistTopics, prevProps.activeWatchlistTopics)
      || (
        !activateFilingsPreloader && activateFilingsPreloader !== prevProps.activateFilingsPreloader
        && !activeWatchlistTopics.length
      )
    ) {
      this.checkForAllTabs();
    }

    if (
      !isEqual(permissions.features, prevProps.permissions.features)
      && this.allTabsChecked
    ) {
      this.checkFeatureBasedTabs();
    }

    const { isChartExpand, isChartExpandFirstTime } = this.state;
    if (isChartExpand && prevProps.location.key !== location.key) {
      if (!isChartExpandFirstTime) {
        return this.setState({
          isChartExpandFirstTime: true,
        });
      }
      this.handleChartCollapseClick();
    }

    if (orderTab !== prevProps.orderTab) {
      this.setState({
        activeOrderTab: orderTab,
      }, () => {
        const { activeOrderTab } = this.state;
        this.handleOrderTabClick(activeOrderTab);
      });
    }

    if (
      (userPreferences[this.userSimplifiedViewProperty] !== undefined)
      && (userPreferences[this.userSimplifiedViewProperty] !== this.userSimplifiedView)
    ) {
      this.userSimplifiedView = userPreferences[this.userSimplifiedViewProperty];
      this.setState({ isAdvancedView: this.userSimplifiedView });
    }
  }

  getFoundID() {
    const { page, history } = this.props;
    const foundID = [
      ...defaultTabs,
      filingsTab,
      investorRelationsTab,
      esgTab,
      insiderTransactionsTab,
      chartsTab,
      infoTab,
      capitalStructureTab,
      sectorsTab,
    ].find((tab) => (
      tab.path === page
      || tab.path === history.location.hash.slice(1)
    )) || {};

    return foundID;
  }

  async getAssetTabData(topic, assetClass) {
    const assetType = this.setTopicAssetType(assetClass);
    const topicTickerArr = orderBy(topic?.tickers?.filter((ticker) => ticker.default), 'priority', 'asc');

    const params = {
      page_limit: 1,
      page: 1,
    };
    let hasChartData;

    for (let i = 0; i < topicTickerArr.length; i += 1) {
      const currentTopic = topicTickerArr[i];
      if (assetType === COMMODITIES || assetType === INDICES || assetType === FOREIGN_EXCHANGE) {
        params.identifiers = `TR:${currentTopic.name}`;
      } else if (assetType === CRYPTOCURRENCIES) {
        params.symbol = currentTopic.name;
      } else {
        params.symbol = currentTopic.full_name;
      }

      // eslint-disable-next-line no-await-in-loop
      const { fullDetails, error } = await fetchTopicFullDetails(assetType, params);
      if (fullDetails && !error) {
        hasChartData = true;
        break;
      }
    }

    return hasChartData;
  }

  setTopicAssetType(assetClass) {
    let assetType;

    if (assetClass === 'Stocks') {
      assetType = PUBLIC_COMPANIES;
    } else if (assetClass === 'Private Companies and Brands') {
      assetType = PRIVATE_COMPANIES;
    } else if (assetClass === 'Cryptocurrencies') {
      assetType = CRYPTOCURRENCIES;
    } else if (assetClass === 'Foreign Exchange and Currencies') {
      assetType = FOREIGN_EXCHANGE;
    } else if (assetClass === 'Commodities') {
      assetType = COMMODITIES;
    } else if (assetClass === 'Exchange Traded Funds (ETFs)') {
      assetType = EXCHANGE_TRADED_FUNDS;
    } else if (assetClass === 'Indices') {
      assetType = INDICES;
    } else {
      assetType = assetClass.toUpperCase();
    }

    return assetType;
  }

  handleOrderTabClick(activeOrderTab) {
    const { actions, token, piwikEnabled } = this.props;
    StorageSvc.setItem(
      'selectedOrderTab',
      JSON.stringify({ activeOrderTab }),
    );
    if (piwikEnabled) _paq.push(['trackEvent', 'Filters', 'Story order', activeOrderTab]);
    this.setState({
      activeOrderTab,
    }, () => {
      const { activeOrderTab } = this.state;
      actions.filterByStoryOrder(activeOrderTab, token);
    });
  }

  handleSentimentTabClick(activeSentimentTab) {
    const { actions, history } = this.props;
    actions.setSentimentTab(activeSentimentTab);
    StorageSvc.setItem(
      'selectedSentimentTab',
      JSON.stringify({ activeSentimentTab }),
    );
    this.setState({
      activeSentimentTab,
    }, () => {
      const { activeSentimentTab } = this.state;
      if (activeSentimentTab) {
        history.push(`/watchlists/news/${activeSentimentTab}`);
      }
    });
  }

  handleChartExpandClick() {
    const { handleTrendingBarStatue } = this.props;
    handleTrendingBarStatue(true);
    this.setState({
      isChartExpand: true,
    });
  }

  handleChartCollapseClick() {
    const { handleTrendingBarStatue } = this.props;
    handleTrendingBarStatue(false);
    this.setState({
      isChartExpand: false,
      isChartExpandFirstTime: false,
    });
  }

  handleSimplifiedViewTabsClick(show) {
    this.fetchSelectedTabs();
    const {
      history, actions, token,
    } = this.props;
    const getSelectedOrderTab = JSON.parse(StorageSvc.getItem('selectedOrderTab'));
    this.handleOrderTabClick(getSelectedOrderTab?.activeOrderTab || 'top');
    this.setState({
      isAdvancedView: show,
    }, () => {
      const { isAdvancedView, activeSentimentTab, activeOrderTab } = this.state;
      if (isAdvancedView) {
        history.push(`/watchlists/news/${activeSentimentTab}`);
        actions.filterByStoryOrder(activeOrderTab, token);
        StorageSvc.setItem(
          'selectedOrderTab',
          JSON.stringify({ activeOrderTab }),
        );
      } else {
        history.push('/watchlists/news');
      }
    });
  }

  fetchSelectedTabs() {
    const { history, actions, token } = this.props;
    const getSelectedOrderTab = JSON.parse(StorageSvc.getItem('selectedOrderTab'));
    const getSelectedSentimentTab = JSON.parse(StorageSvc.getItem('selectedSentimentTab'));
    const sentimentName = history.location.pathname.split('/').reverse()[0];

    if (getSelectedOrderTab?.activeOrderTab) {
      this.setState({
        activeOrderTab: getSelectedOrderTab?.activeOrderTab || 'top',
      }, () => {
        const { activeOrderTab } = this.state;
        if (activeOrderTab !== 'latest') {
          actions.filterByStoryOrder(activeOrderTab, token);
        }
      });
    }
    if (['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) {
      this.setState({
        activeSentimentTab: sentimentName,
      }, () => {
        const { activeSentimentTab } = this.state;
        StorageSvc.setItem(
          'selectedSentimentTab',
          JSON.stringify({ activeSentimentTab }),
        );
      });
    } else if (getSelectedSentimentTab?.activeSentimentTab) {
      this.setState({
        activeSentimentTab: getSelectedSentimentTab?.activeSentimentTab || 'all',
      });
    }
  }

  generateTabs() {
    const {
      isFilingsTab,
      isIRTab,
      isESGTab,
      isChartTab,
      isInfoTab,
      insiderTransactionsExists,
      sectorsExists,
      isCapitalStructureTab,
      activeTab,
    } = this.state;
    const newTabs = cloneDeep(defaultTabs);
    let newActiveTab = activeTab;

    if (isFilingsTab) {
      newTabs.push(filingsTab);
    } else {
      newActiveTab = newActiveTab === 2 ? 1 : newActiveTab;
    }
    if (isIRTab) {
      newTabs.push(investorRelationsTab);
    } else {
      newActiveTab = newActiveTab === 6 ? 1 : newActiveTab;
    }
    if (isESGTab) {
      newTabs.push(esgTab);
    } else {
      newActiveTab = newActiveTab === 7 ? 1 : newActiveTab;
    }
    if (isChartTab) {
      newTabs.push(chartsTab);
    } else {
      newActiveTab = newActiveTab === 4 ? 1 : newActiveTab;
    }
    if (insiderTransactionsExists) {
      newTabs.push(insiderTransactionsTab);
    }
    if (sectorsExists) {
      newTabs.push(sectorsTab);
    }
    if (isInfoTab) {
      newTabs.push(infoTab);
    } else {
      newActiveTab = newActiveTab === 5 ? 1 : newActiveTab;
    }
    if (isCapitalStructureTab) {
      newTabs.push(capitalStructureTab);
    } else {
      newActiveTab = newActiveTab === 9 ? 1 : newActiveTab;
    }
    this.setState(({ isGettingData }) => ({
      tabsArray: orderBy(newTabs, 'priority'),
      ...(!isGettingData ? { activeTab: newActiveTab } : {}),
    }), () => {
      const { isGettingData, tabsArray, activeTab: currentTabNumber } = this.state;
      if (!isGettingData) {
        const { page } = this.props;
        const tabDetails = tabsArray.find((tab) => tab.id === currentTabNumber);
        if (!tabDetails || (tabDetails || {}).path !== page) {
          const { history } = this.props;
          history.replace('/watchlists/news');
        }
      }
    });
  }

  checkForAllTabs() {
    const { activeTab } = this.state;
    this.setState({
      isGettingData: activeTab !== 1,
      isFilingsTab: false,
      isIRTab: false,
      isESGTab: false,
      isChartTab: false,
      isInfoTab: false,
      insiderTransactionsExists: false,
      sectorsExists: false,
      isCapitalStructureTab: false,
    });
    const { activeWatchlistTopics, actions, wlPageLoadingStep } = this.props;
    const activeTopics = activeWatchlistTopics.filter((item) => !item.hidden);

    if (activeTopics.length) {
      if (wlPageLoadingStep === 'LOADED') {
        actions.setWatchlistLoadStatus('LOADING_TOPICS_DATA');
      }
    } else {
      actions.setWatchlistLoadStatus('LOADED');
    }

    this.checkForFilingsTab(activeTopics);
    this.checkFeatureBasedTabs();
    this.checkForSingleTopicTab(activeTopics);
    this.checkInsiderTransactionsExistence(activeTopics);

    const tabsBar = this.tabsBar.current;
    let offset = 0;

    if (tabsBar && tabsBar.topicMain && tabsBar.topicMain.current) {
      const tabTop = tabsBar.topicMain.current.getBoundingClientRect().top;
      offset = tabTop <= 0 ? window.pageYOffset + tabTop : 0;
    }
    this.scrollTo(offset, () => { });
    this.allTabsChecked = true;
  }

  checkFeatureBasedTabs() {
    const { activeWatchlistTopics, permissions } = this.props;
    if (!permissions?.features?.length) {
      return;
    }

    const activeTopics = activeWatchlistTopics.filter((item) => !item.hidden);
    const extraProps = activeTopics
      .filter((f) => f.entity_type === 'Stocks' || f.entity_type === 'Private Companies and Brands')
      .map(({
        query,
        name,
        tickers,
        slug: mainSlug,
      }) => {
        const { name: topicName } = query ? queryItemWatchlistParser(query) : { name };
        const identifiers = presentationsParamGenerate({
          name: topicName,
          tickers: (tickers || []),
          slug: mainSlug,
        });

        return identifiers;
      }).filter((f) => f).join(',');

    this.checkForIRTab(extraProps);
    this.checkForESGTab(extraProps);
  }

  async checkForFilingsTab(activeTopics) {
    const extraProps = activeTopics.map((watchlist) => {
      const {
        legal_entities: legalEntities, tickers, entity_type: entityType,
      } = watchlist;

      const assetType = this.setTopicAssetType(entityType);
      const identifier = filingsParamGenerate({
        tickers,
        legal_entities: legalEntities,
      }, assetType);

      return identifier;
    }).filter((f) => f).join(',');

    let isFilingsTab = false;
    if (extraProps) {
      let data;
      try {
        const { data: APIData } = await FilingsSvc.getFillings({
          param: {
            per: 1,
            identifier: extraProps,
          },
        });
        data = APIData || [];
      } catch (err) {
        data = [];
      }
      if ((data || []).length) {
        isFilingsTab = true;
      }
    }

    const { page } = this.props;
    this.setState({
      isFilingsTab,
      ...(page === 'filings' ? { isGettingData: false } : {}),
    }, () => {
      this.generateTabs();
    });
  }

  async checkInsiderTransactionsExistence(topics) {
    const { page } = this.props;
    let transactionsData = [];

    if (!topics?.length) {
      return;
    }

    const candidateTopics = topics
      .filter((topic) => (
        (
          topic.entity_type === 'Stocks'
          || topic.entity_type === 'Private Companies and Brands'
          || topic.entity_type === 'Exchange Traded Funds (ETFs)'
          || topic.entity_type === 'Closed-End Funds'
        ) && topic.tickers?.some((ticker) => ticker.full_name?.endsWith('_US'))
      ));
    if (candidateTopics.length) {
      const tickers = candidateTopics.flatMap((topic) => (
        getInsiderTransactionTickers(topic)
      ));

      ({
        transactions: transactionsData,
      } = await tryInsiderTransactions(
        tickers,
        candidateTopics.length > 1 ? {
          per: 25,
          page: 1,
        } : {},
      ));
    }

    this.setState({
      insiderTransactionsExists: !!transactionsData.length,
      insiderTransactionsTopics: candidateTopics,
      ...(page === insiderTransactionsTab.path && {
        isGettingData: false,
      }),
    }, this.generateTabs);
  }

  async callIRApi(props) {
    return PresentationsSvc.getPresentationsData(props)
      .then(({ data }) => data || [])
      .catch(() => []);
  }

  async checkForIRTab(extraProps) {
    const { permissions } = this.props;
    const hasIRAccess = (permissions.features || []).includes(IR);

    let isIRTab = false;
    if (hasIRAccess && extraProps) {
      const data = await this.callIRApi({
        per: 1,
        identifiers: extraProps,
      });
      if (data.length) {
        isIRTab = true;
      }
    }

    const { page } = this.props;
    this.setState({
      isIRTab,
      ...(page === 'investor-relations' ? { isGettingData: false } : {}),
    }, () => {
      this.generateTabs();
    });
  }

  async callESGApi(props) {
    return PresentationsSvc.getPresentationsEsgData(props)
      .then(({ data }) => data || [])
      .catch(() => []);
  }

  async checkForESGTab(extraProps) {
    const { permissions } = this.props;
    const hasEGSAccess = (permissions.features || []).includes(ESG);

    let isESGTab = false;
    if (hasEGSAccess && extraProps) {
      const data = await this.callESGApi({
        per: 1,
        identifiers: extraProps,
      });
      if (data.length) {
        isESGTab = true;
      }
    }

    const { page } = this.props;
    this.setState({
      isESGTab,
      ...(page === 'esg' ? { isGettingData: false } : {}),
    }, () => {
      this.generateTabs();
    });
  }

  async checkForSingleTopicTab(activeTopics) {
    const { page, token } = this.props;

    let isChartTab = false;
    let isInfoTab = false;
    let isCapitalStructureTab = false;
    let sectorsExists = false;
    let activeTopic = null;
    if (activeTopics.length === 1 || (page === 'info' && !token)) {
      const selectedTopic = activeTopics[0] || {};
      const type = selectedTopic.entity_type
        ? selectedTopic.entity_type
        : selectedTopic.groups[0].groupType;

      if (
        (
          type === 'Stocks' || type === 'Cryptocurrencies' || type === 'Foreign Exchange and Currencies'
          || type === 'Commodities' || type === 'Exchange Traded Funds (ETFs)' || type === 'Indices'
        )
        && selectedTopic) {
        isChartTab = await this.getAssetTabData(selectedTopic, type);
      }
      if (type === 'Stocks' || type === 'Private Companies and Brands') {
        isInfoTab = true;
      }
      if (type === 'Private Companies and Brands') {
        isCapitalStructureTab = true;
      }
      if (isChartTab || isInfoTab || isCapitalStructureTab) {
        const { token } = this.props;
        const id = !token ? Number(selectedTopic.id) : Number(selectedTopic?.query?.split(':')[2]);
        if (!id) {
          return;
        }
        activeTopic = await TopicsSvc.getTopicById(id);
        if (!(activeTopic?.legal_entities || []).length && !(activeTopic?.tickers || []).length) {
          isInfoTab = false;
        }
        isCapitalStructureTab = isCapitalStructureTab
          && !!(activeTopic.legal_entities || []).length;
      }
      const { relevances: response } = await DCSCSectorsSvc.getRelevantCompanies({
        topicId: Number(!token ? selectedTopic.id : selectedTopic?.query?.split(':')[2]),
      });
      sectorsExists = !!response.length;
      this.setState({
        topicAssetType: this.setTopicAssetType(type),
      });
    }

    this.setState({
      isChartTab,
      isInfoTab,
      activeTopic,
      isCapitalStructureTab,
      sectorsExists,
      ...((page === 'charts' || page === 'info' || page === CAPITAL_STRUCTURE || page === sectorsTab.path) ? { isGettingData: false } : {}),
    }, () => {
      this.generateTabs();
    });
  }

  scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed();
    // eslint-disable-next-line func-names
    const onScroll = function () {
      if (window.pageYOffset.toFixed() === fixedOffset) {
        window.removeEventListener('scroll', onScroll);
        callback();
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll();
    window.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  }

  switchTab(tabNumber, offset) {
    const { piwikEnabled } = this.props;

    if (!offset) {
      const { tabsArray } = this.state;
      let isAdvancedLayout = JSON.parse(StorageSvc.getItem('userSimplifiedView'));

      if (isAdvancedLayout === null) {
        isAdvancedLayout = true;
      }
      const { path } = tabsArray.find((tab) => tab.id === tabNumber);
      const { history, actions } = this.props;
      actions.setWatchlistLoadStatus('LOADING_TOPICS_DATA');
      this.setState({
        activeTab: tabNumber,
        isAdvancedView: tabNumber === 1 ? isAdvancedLayout : true,
      }, () => {
        const { isAdvancedView, activeSentimentTab, activeTab } = this.state;
        if (isAdvancedView && activeTab === 1) {
          history.push(`/watchlists/${path}/${activeSentimentTab}`);
        } else {
          history.push(`/watchlists/${path}`);
        }
      });
      if (piwikEnabled) {
        _paq.push(['trackEvent', 'WL tabs', `Tab: ${tabNumber}`]);
      }
      return;
    }
    this.scrollTo(offset, () => {
      this.switchTab(tabNumber, null);
    });
  }

  toggleInternalStories() {
    this.setState(({ internalContentExpanded }) => ({
      internalContentExpanded: !internalContentExpanded,
    }));
  }

  changeNewsTabEvent(eventKey) {
    this.setState({
      activeNewsTab: eventKey,
    });
  }

  changeTab(id, offset) {
    if (!offset) {
      let { tabs } = this.state;
      const { page, history } = this.props;
      tabs = tabs.map((tab) => ({
        ...tab,
        active: tab.id === id,
      }));

      const { path } = tabs.find((tab) => tab.active);
      if (page) {
        history.push(`${removeSlugFromPath(window.location.pathname)}/${path}`);
      } else {
        window.location.hash = path;
      }

      this.setState({ tabs });
      return;
    }
    this.scrollTo(offset, () => {
      this.changeTab(id, null);
    });
  }

  changeIsWatchlistUpdatedValue(isWatchlistUpdated) {
    this.setState({
      isWatchlistUpdated,
    });
  }

  renderComponent() {
    const {
      user, width,
      piwikEnabled, activateFilingsPreloader, token, activeWatchlistTopics,
      wlPageLoadingStep,
    } = this.props;
    const {
      activeTab,
      internalContentExpanded,
      isGettingData,
      activeNewsTab,
      activeTopic,
      topicAssetType,
      isAdvancedView,
      isWatchlistUpdated,
      insiderTransactionsExists,
      insiderTransactionsTopics,
      activeSentimentTab,
    } = this.state;

    if (wlPageLoadingStep === 'LOADING_WL') {
      return null;
    }

    let activeTabNumber = activeTab;
    if (wlPageLoadingStep === 'LOADED' && (activateFilingsPreloader || isGettingData)) {
      return <Preloader top="30vh" loading centered static />;
    }

    const isOneTopicSelected = activeWatchlistTopics.some(({ hidden }) => !hidden);
    const activeTopics = activeWatchlistTopics.filter((item) => !item.hidden);
    if (!activateFilingsPreloader && (!activeWatchlistTopics.length || !isOneTopicSelected)) {
      return <NoWLData changeIsWatchlistUpdatedValue={this.changeIsWatchlistUpdatedValue} />;
    }
    if (activeTabNumber === 4 && activeTopics.length > 1) {
      activeTabNumber = 1;
    }
    switch (activeTabNumber) {
      case 2:
        return (
          <Filings piwikEnabled={piwikEnabled} />
        );
      case 4:
        return (
          <div className={Styles.charts_container}>
            <ChartsAndData
              isWatchlist
              slug={activeTopic}
              assetType={topicAssetType}
              onChartExpandClick={this.handleChartExpandClick}
            />
          </div>
        );
      case 5:
        return (
          <div className={Styles.info_container}>
            <Info slug={activeTopic} assetType={topicAssetType} />
          </div>
        );
      case 6:
        return (
          <InvestorRelations piwikEnabled={piwikEnabled} />
        );
      case 7:
        return (
          <ESGComponent />
        );
      case 8:
        return insiderTransactionsExists && (
          <InsiderTransactions
            topics={insiderTransactionsTopics}
            multipleTopics={activeTopics.length > 1}
          />
        );
      case 9:
        return (
          <div className={Styles.capital_structure_container}>
            <CapitalStructure isWatchlist slug={activeTopic} />
          </div>
        );
      case sectorsTab.id:
        return (
          <SectorsTab topic={activeTopic} />
        );
      default:
        if (width > 1024 || !token) {
          return (
            <WatchlistNews
              user={user}
              piwikEnabled={piwikEnabled}
              internalContentExpanded={internalContentExpanded}
              toggleInternalStories={this.toggleInternalStories}
              onSimplifiedViewTabsClick={this.handleSimplifiedViewTabsClick}
              isAdvancedLayout={isAdvancedView}
              activeSentimentTab={activeSentimentTab}
              isWatchlistUpdatedProps={isWatchlistUpdated}
              changeIsWatchlistUpdatedValue={this.changeIsWatchlistUpdatedValue}
            />
          );
        }
        return (
          <div className={Styles.news_tabs_holder}>
            <BootstrapTabs
              id="WL_news_tabs"
              defaultActiveKey={activeNewsTab}
              onSelect={this.changeNewsTabEvent}
            >
              <Tab eventKey={1} title="Stories" tabClassName={Styles.custom_nav_item}>
                <WatchlistNews
                  user={user}
                  piwikEnabled={piwikEnabled}
                  internalContentExpanded={internalContentExpanded}
                  toggleInternalStories={this.toggleInternalStories}
                  onSimplifiedViewTabsClick={this.handleSimplifiedViewTabsClick}
                  isAdvancedLayout={isAdvancedView}
                  isWatchlistUpdatedProps={isWatchlistUpdated}
                  changeIsWatchlistUpdatedValue={this.changeIsWatchlistUpdatedValue}
                />
              </Tab>
              <Tab eventKey={2} title="Sentiment" tabClassName={Styles.custom_nav_item}>
                <div className={Styles.tab_sentiment_holder}>
                  {
                    activeNewsTab === '2' ? (
                      <SentimentAnalysis
                        isWatchlistPage
                        isTabView
                      />
                    ) : null
                  }
                </div>
              </Tab>
            </BootstrapTabs>
          </div>
        );
    }
  }

  render() {
    const {
      user,
      userPreferences,
      trendingStillAnimating,
      trendingBarTopicPopover,
      trendingBarFiltersOpened,
      client,
      width,
      hideRightBarHolder,
      activeWatchlistTopics,
    } = this.props;

    const {
      activeTab,
      internalContentExpanded,
      rendered,
      isGettingData,
      tabsArray,
      isChartExpand,
      activeTopic,
      topicAssetType,
      isAdvancedView,
      activeOrderTab,
      activeSentimentTab,
    } = this.state;

    const watchlistWrapperClass = cx({
      watchlist_wrapper: true,
      loading_trending_bar: trendingBarTopicPopover || trendingBarFiltersOpened,
      tablet_view: hideRightBarHolder,
    });

    const storiesWrapperClass = cx({
      stories_list_wrapper: true,
      is_trending: rendered && userPreferences.show_trending_asset_bar,
      closing_trending: trendingStillAnimating,
      full_width: hideRightBarHolder,
    });

    if (isChartExpand) {
      return (
        <div className={Styles.watchlist_charts}>
          <ChartsExpand
            isWatchlist
            topic={activeTopic}
            assetType={topicAssetType}
            onChartCollapseClick={this.handleChartCollapseClick}
          />
        </div>
      );
    }

    const activeTopics = activeWatchlistTopics.filter((item) => !item.hidden);

    return (
      <div className={watchlistWrapperClass}>
        <div className={storiesWrapperClass}>
          <WatchlistFilters
            user={user}
            expanded={internalContentExpanded}
            className={Styles.internal_content}
            desktopView={width > 1024}
            page="WATCHLIST"
            isWatchlistPage={activeTab === 1}
          />
          {
            !isGettingData && !!activeTopics.length && (
              <>
                <TopicTab
                  tabs={tabsArray}
                  changeTab={this.switchTab}
                  activeTab={activeTab}
                  ref={this.tabsBar}
                  className={cx('main-tabs')}
                />
                <div className={cx('simplifiedview__Tabs', { show: (activeTab === 1 && isAdvancedView) })}>
                  <ScrollableTabs
                    tabs={orderValuesTab}
                    activeTab={activeOrderTab}
                    onTabClick={this.handleOrderTabClick}
                    ref={this.tabsBar}
                    classname="subTab"
                  />
                  <ScrollableTabs
                    tabs={sentimentValuesTab}
                    activeTab={activeSentimentTab}
                    onTabClick={this.handleSentimentTabClick}
                    ref={this.tabsBar}
                    classname="subTab"
                  />
                </div>
              </>
            )
          }
          <div className={cx('filters_body_wrapper', { show: (activeTab === 1 && isAdvancedView) })}>
            {this.renderComponent()}
          </div>
        </div>

        {!hideRightBarHolder ? (
          <WatchlistRigthBar
            isFilingsPage={activeTab === 2 || isGettingData}
            client={client}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({
  watchlistReducer,
  userPreferencesReducer,
  trendingBarReducer,
  common,
  subscriptions,
  storyFilters,
  chatbot,
}) => ({
  internalStories: watchlistReducer.activeWatchlistInternalStories,
  internalLoading: watchlistReducer.internalLoading,
  userPreferences: userPreferencesReducer.preferences,
  activeWatchlistTopics: watchlistReducer.activeWatchlistTopics,
  activatePreloader: watchlistReducer.activatePreloader,
  activateFilingsPreloader: watchlistReducer.activateFilingsPreloader,
  trendingBarTopicPopover: trendingBarReducer.trendingBarTopicPopover,
  trendingBarFiltersOpened: trendingBarReducer.trendingBarFiltersOpened,
  token: watchlistReducer.userToken,
  width: common.width,
  permissions: subscriptions.permissions,
  selectedOrderTab: storyFilters.selected_order_tab,
  selectedSentimentTab: storyFilters.selected_sentiment_tab,
  orderTab: storyFilters.order_by,
  hideRightBarHolder: chatbot.isChatbotOpened && (common.width > 1024 && common.width < 1500),
  wlPageLoadingStep: watchlistReducer.wlPageLoadingStep,
});

function mapDispatchToProps(dispatch) {
  return {
    loadIRStorageDataIntoRedux,
    loadESGStorageDataIntoRedux,
    actions: bindActionCreators({
      ...storyFiltersActions,
      ...storyActions,
      ...watchlistActions,
      ...searchActions,
    }, dispatch),
  };
}

export default withRouter(
  withComponentName(
    connect(mapStateToProps, mapDispatchToProps)(WatchlistBody),
  ),
);
